"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preact2 = _interopRequireDefault(require("downshift/preact"));

var _algoliaService = require("../../../services/algoliaService");

var _HitContainerWithFederated = _interopRequireDefault(require("./HitContainerWithFederated"));

var _index = require("./index");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _SearchBox = require("./SearchBox");

var _localStorageCache = _interopRequireDefault(require("../../../utils/localStorageCache"));

var _config = require("../../../libs/config");

var _publish = _interopRequireDefault(require("../../../components/tracker/publish"));

var _Analytics = _interopRequireDefault(require("../../analytics/Analytics"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var eventTrackerInfo = function eventTrackerInfo(hit, type, idx) {
  var _hit$topic_url, _hit$topic_url2;

  var resultType = 'Yip.CommunityResultClicked';

  if (type === 'zendesk') {
    resultType = 'Yip.ZendeskGuideResultClicked';
  }

  if (type === 'salesforce') {
    resultType = 'Yip.SalesforceKBResultClicked';
  }

  if (type === 'skilljar') {
    resultType = 'Yip.SkilljarResultClicked';
  }

  if (type === 'freshdesk') {
    resultType = 'Yip.FreshdeskResultClicked';
  }

  if (type === 'federated') {
    resultType = 'Yip.FedereatedResultClicked';
  }

  if (type === 'thoughtindustries') {
    resultType = 'Yip.ThoughtIndustriesResultClicked';
  }

  var track = {
    type: resultType,
    topic_url: (_hit$topic_url = hit.topic_url) !== null && _hit$topic_url !== void 0 ? _hit$topic_url : '',
    click_source: 'live-search',
    topic_position: idx,
    topic_title: hit.title,
    topic_topic_type: (0, _index.isCommunityResult)(hit) ? hit.content_type : type
  };

  if ((0, _index.isCommunityResult)(hit) && !(0, _index.isCommunityResultEvent)(hit)) {
    track.category_id = hit.forum;
    track.category_title = hit.forum_title;
  }

  var gaEvents = {
    eventCategory: 'Live Search',
    eventAction: 'Topic Clicked',
    eventLabel: {
      Link: (_hit$topic_url2 = hit.topic_url) !== null && _hit$topic_url2 !== void 0 ? _hit$topic_url2 : '',
      Position: idx,
      Type: (0, _index.isCommunityResult)(hit) ? hit.content_type : type
    }
  };
  return {
    track: track,
    gaEvents: gaEvents
  };
};

var AlgoliaSearch = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AlgoliaSearch, _Component);

  var _super = _createSuper(AlgoliaSearch);

  function AlgoliaSearch() {
    var _this;

    (0, _classCallCheck2.default)(this, AlgoliaSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "stateReducer", function (state, changes) {
      switch (changes.type) {
        // prevent closing of the popup on certain actions
        case _preact2.default.stateChangeTypes.mouseUp:
        case _preact2.default.stateChangeTypes.touchStart:
          return {};
        // prevent clicking/selecting items from overwriting inputValue

        case _preact2.default.stateChangeTypes.keyDownEnter:
        case _preact2.default.stateChangeTypes.clickItem:
          return _objectSpread(_objectSpread({}, changes), {}, {
            inputValue: state.inputValue,
            highlightedIndex: null
          });

        case _preact2.default.stateChangeTypes.blurInput:
        case _preact2.default.stateChangeTypes.keyDownEscape:
          {
            if (_this.props.callbackOnOutsideClick !== undefined && typeof _this.props.callbackOnOutsideClick === 'function') {
              _this.props.callbackOnOutsideClick();
            }

            return _objectSpread(_objectSpread({}, changes), {}, {
              inputValue: state.inputValue,
              highlightedIndex: null
            });
          }

        default:
          return changes;
      }
    });
    return _this;
  }

  (0, _createClass2.default)(AlgoliaSearch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          refine = _this$props.refine,
          updateSearch = _this$props.updateSearch,
          allSearchResults = _this$props.allSearchResults,
          indexName = _this$props.indexName,
          enableFocusToSearch = _this$props.enableFocusToSearch,
          callbackOnOutsideClick = _this$props.callbackOnOutsideClick;
      return (0, _preact.h)(_preact2.default, {
        itemToString: itemToString,
        stateReducer: this.stateReducer,
        onChange: handleOnChange
      }, function (_ref) {
        var getInputProps = _ref.getInputProps,
            getItemProps = _ref.getItemProps,
            highlightedIndex = _ref.highlightedIndex,
            setHighlightedIndex = _ref.setHighlightedIndex,
            closeMenu = _ref.closeMenu,
            openMenu = _ref.openMenu,
            inputValue = _ref.inputValue,
            reset = _ref.reset,
            clearSelection = _ref.clearSelection,
            isOpen = _ref.isOpen;
        return (0, _preact.h)("div", {
          className: "algolia-search-container",
          "aria-expanded": "false",
          "aria-owns": "downshift-2-menu"
        }, (0, _preact.h)("div", {
          className: "".concat(!inputValue ? 'algolia-search-container--empty-input' : '')
        }, isOpen ? (0, _preact.h)("div", {
          key: "backdrop",
          onClick: function onClick() {
            closeMenu();

            if (callbackOnOutsideClick !== undefined && typeof callbackOnOutsideClick === 'function') {
              callbackOnOutsideClick();
            }
          },
          className: "algolia-search--opacity",
          "aria-hidden": "true",
          tabIndex: -1
        }) : null, (0, _preact.h)(_SearchBox.SearchBox, {
          reset: reset,
          clearSelection: clearSelection,
          refine: refine,
          updateSearch: updateSearch,
          setHighlightedIndex: setHighlightedIndex,
          inputValue: inputValue !== null && inputValue !== void 0 ? inputValue : '',
          getInputProps: getInputProps,
          openMenu: openMenu,
          isOpen: isOpen,
          enableFocusToSearch: enableFocusToSearch,
          key: "search"
        }), inputValue && isOpen ? (0, _preact.h)(_HitContainerWithFederated.default, {
          key: "hits-container",
          allSearchResults: allSearchResults,
          inputValue: inputValue,
          doSearch: _SearchBox.doSearch,
          highlightedIndex: highlightedIndex,
          showFooterLinks: true,
          setHighlightedIndex: setHighlightedIndex,
          getItemProps: getItemProps,
          indexName: indexName
        }) : null));
      });
    }
  }]);
  return AlgoliaSearch;
}(_preact.Component);

function itemToString(i) {
  return i ? i.title : i;
}

function isSimpleUrl(item) {
  return !('objectID' in item);
}

function getResultType(item) {
  var resultType = 'community';
  var type = item.indexName.split('-').pop();
  if (type === 'zendesk') resultType = 'zendesk';
  if (type === 'salesforce') resultType = 'salesforce';
  if (type === 'skilljar') resultType = 'skilljar';
  if (type === 'freshdesk') resultType = 'freshdesk';
  if (type === 'federated') resultType = 'federated';
  if (type === 'federated' && item.source === 'thoughtindustries') resultType = 'thoughtindustries';
  return resultType;
}

function trackEvent(item) {
  var resultType = getResultType(item);

  var _eventTrackerInfo = eventTrackerInfo(item, resultType, item.position),
      track = _eventTrackerInfo.track,
      gaEvents = _eventTrackerInfo.gaEvents;

  _publish.default.trackEvent('userevent', track);

  _Analytics.default.send(gaEvents.eventCategory, gaEvents.eventAction, gaEvents.eventLabel);
}

function handleOnChange(item) {
  if (item === null) {
    return;
  }

  if (isSimpleUrl(item)) {
    var _item$url;

    window.location.href = (0, _absoluteUrlRuntime.resolveUrl)((_item$url = item.url) !== null && _item$url !== void 0 ? _item$url : '');
  }

  (0, _algoliaService.insights)('clickedObjectIDsAfterSearch', {
    objectIDs: [item.objectID],
    eventName: 'Live search item click',
    positions: [item.position],
    queryID: item.queryID,
    index: item.indexName
  });
  trackEvent(item);

  _localStorageCache.default.setItem(_config.SEARCH_CONVERSION, {
    objectIDs: [item.objectID],
    queryID: item.queryID,
    index: item.indexName
  }); // user pressed enter to select the item


  if ('KeyboardEvent' in window && window.event instanceof window.KeyboardEvent) {
    var _item$topic_url;

    if (/^https?/.test((_item$topic_url = item.topic_url) !== null && _item$topic_url !== void 0 ? _item$topic_url : '')) {
      window.open(item.topic_url, '_blank');
    } else {
      var _ref2, _item$topic_url2;

      window.location.href = (0, _absoluteUrlRuntime.resolveUrl)((_ref2 = (_item$topic_url2 = item.topic_url) !== null && _item$topic_url2 !== void 0 ? _item$topic_url2 : item.url) !== null && _ref2 !== void 0 ? _ref2 : '');
    }
  }
}

var _default = AlgoliaSearch;
exports.default = _default;